import { render } from "./ProcuratDialog.vue?vue&type=template&id=a4c1f9bc&scoped=true"
import script from "./ProcuratDialog.vue?vue&type=script&lang=js"
export * from "./ProcuratDialog.vue?vue&type=script&lang=js"

import "./ProcuratDialog.vue?vue&type=style&index=0&id=a4c1f9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c1f9bc"]])

export default __exports__